// Dictamen final, estatus operativo y acción inmediata según % de
// evaluación. Textos actualizados al spec de Marco (#SYIO3rkl,
// #8YqCht2a, #zkIP5lWR, #RxVS7d9E):
//
//   >80   Riesgo Bajo       — Operación Normal       — Cumple los criterios; documentar buenas prácticas
//   >60   Riesgo Moderado   — Operación Condicionada — Requiere plan de mitigación aprobado antes del próximo evento
//   >40   Riesgo Alto       — Operación Restringida  — Aplicar acciones correctivas urgentes y revalidar
//   ≤40   Riesgo Crítico    — Operación Suspendida   — Suspender el evento hasta corregir criterios críticos
//
// #Fase0-B4 — el corte ya no se escribe aquí (antes ≥81/≥61/≥41, que con
// decimales no coincidía con el semáforo del servidor): sale de
// getSemaforoKey (contrato C1). Los textos se quedan como estaban.
import { getSemaforoKey } from './criteria';

export function getDictamen(percentage) {
  // #Fase1-10 — Un porcentaje nulo no permite emitir un dictamen de riesgo.
  if (percentage == null)
    return {
      dictamen: 'Sin calificación',
      estatus: '—',
      accion: 'Sin calificación disponible.',
      color: 'text-slate-500',
      bg: 'bg-slate-50 border-slate-200',
      dot: '#94a3b8',
      emoji: '⚪',
    };
  const level = getSemaforoKey(percentage);
  if (level === 'bajo') return {
    dictamen: 'Riesgo Bajo',
    estatus: 'Operación Normal',
    accion: 'Cumple con los criterios de seguridad requeridos. Documentar buenas prácticas y mantener controles.',
    color: 'text-green-700',
    bg: 'bg-green-50 border-green-200',
    dot: '#15803D',
    emoji: '🟢',
  };
  if (level === 'medio') return {
    dictamen: 'Riesgo Moderado',
    estatus: 'Operación Condicionada',
    accion: 'Requiere plan de mitigación aprobado antes del próximo evento.',
    color: 'text-yellow-700',
    bg: 'bg-yellow-50 border-yellow-200',
    dot: '#CA8A04',
    emoji: '🟡',
  };
  if (level === 'alto') return {
    dictamen: 'Riesgo Alto',
    estatus: 'Operación Restringida',
    accion: 'Aplicar acciones correctivas urgentes antes del evento y revalidar.',
    color: 'text-orange-700',
    bg: 'bg-orange-50 border-orange-200',
    dot: '#D97706',
    emoji: '🟠',
  };
  return {
    dictamen: 'Riesgo Crítico',
    estatus: 'Operación Suspendida',
    accion: 'Suspender el evento hasta corregir todos los criterios críticos.',
    color: 'text-red-700',
    bg: 'bg-red-50 border-red-200',
    dot: '#DC2626',
    emoji: '🔴',
  };
}

export function DictamenCard({ percentage, compact = false, showPercentage = true }) {
  if (!percentage && percentage !== 0) return null;
  const d = getDictamen(percentage);
  if (compact) {
    return (
      <div className={`border rounded-sm px-3 py-2 ${d.bg} space-y-0.5`}>
        <div className="flex items-center gap-2">
          <span className="text-sm">{d.emoji}</span>
          <span className={`text-xs font-bold ${d.color}`}>{d.dictamen}</span>
          {showPercentage && <span className={`text-xs ${d.color}`}>({percentage.toFixed(1)}%)</span>}
        </div>
        <p className={`text-xs ${d.color} ml-6`}>{d.accion}</p>
      </div>
    );
  }
  return (
    <div className={`border rounded-sm p-3 ${d.bg}`}>
      <div className="grid grid-cols-3 gap-3">
        <div>
          <p className="soem-label mb-0.5">Dictamen Final</p>
          <p className={`text-sm font-bold ${d.color} flex items-center gap-1`}>{d.emoji} {d.dictamen}</p>
        </div>
        <div>
          <p className="soem-label mb-0.5">Estatus Operativo</p>
          <p className={`text-sm font-bold ${d.color}`}>{d.estatus}</p>
        </div>
        <div>
          <p className="soem-label mb-0.5">Acción Inmediata</p>
          <p className={`text-xs font-semibold ${d.color}`}>{d.accion}</p>
        </div>
      </div>
    </div>
  );
}
